"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguagesContract = void 0;
const core_1 = require("@ts-rest/core");
const languages_request_1 = require("./languages.request");
const languages_response_1 = require("./languages.response");
exports.LanguagesContract = (0, core_1.initContract)().router({
    getById: {
        method: 'GET',
        path: '/:languageId',
        responses: { 200: languages_response_1.LanguageGetByIdResponseSchema },
        pathParams: languages_request_1.LanguageIdPathParamsSchema,
    },
    list: {
        method: 'GET',
        path: '/',
        responses: { 200: languages_response_1.LanguageListResponseSchema },
    },
}, { pathPrefix: '/languages' });
